/* eslint-disable import/no-mutable-exports */

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import config from 'src/globals';
import { getMessaging } from 'firebase/messaging';
import { message } from 'antd';

const { FIREBASE_CONFIG = {}, FIRESTORE_DB_ID } = config;

// Initialize Firebase
const isFirebaseConfigEmpty = Object.keys(FIREBASE_CONFIG).length === 0;

let app = null;
let messaging = null;
let firestore = null;
let auth = null;

try {
  if (!isFirebaseConfigEmpty && FIRESTORE_DB_ID) {
    app = initializeApp(FIREBASE_CONFIG);
    const { userAgent } = navigator;
    messaging = !userAgent.includes('iPhone') ? getMessaging(app) : null;
    firestore = getFirestore(app, FIRESTORE_DB_ID);
    auth = getAuth(app);
  }
} catch (error) {
  message.error('Error initializing Firebase');
}

export { messaging, firestore, auth };
